import Switch from "./Switch"
import Toggle from "./Toggle"

export default Object.assign(Switch, { Toggle })
